import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  lista: banco => {
    return Vue.http.get(`/api/agencias/${banco}`).then(response => response.data);
  }
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/agencia/servico.js